import { createStandardAction } from 'typesafe-actions';
import * as Types from './types';


export const searchDeveloper = createStandardAction(Types.SEARCH_DEVELOPER)<{ cityDocId: string; page?: number; }>();
